module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bc-notice",
    class: {
      'bc-notice--in': _vm.visible
    }
  }, [_c('div', {
    staticClass: "bc-notice__label"
  }, [_vm._v(_vm._s(_vm.$T('官网公告栏标题')))]), _vm._v(" "), _vm._l((_vm.items), function(item, idx) {
    return _c('button', {
      key: item,
      staticClass: "bc-notice__item",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.onSelect
      }
    }, [_c('span', {
      staticClass: "bc-notice__idx"
    }, [_vm._v(_vm._s(idx + 1) + ".")]), _vm._v(" "), _c('span', {
      staticClass: "bc-notice__text"
    }, [_vm._v(_vm._s(_vm.$T(item)))])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-784eba4d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/BcHeroNotice.vue
// module id = 1528
// module chunks = 0